import React from 'react';
import AuthContainer from '../../components/Auth/AuthContainer';

const Login = () => {
  return <AuthContainer mode="login" />;
};

export default Login;
